<script lang="ts">
	import { format } from 'svelte-i18n';
	import { onMount } from 'svelte';

	import { homes, refreshHomes } from 'src/stores/account/home';

	import SharedHomeItem from 'src/components/Settings/HomeManagement/SharedHomeItem.svelte';

	import { Loader, Text } from '@Shelly/shelly-design-system';

	$: ({ list, fetchStatus } = $homes);
	$: sharedHomes = list
		.filter((home) => home.isShared)
		.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
	$: isFetching = fetchStatus === 'loading';

	// Ensure the homes list (source of the shared-to-me entries) is loaded even
	// if the user lands here before any dropdown / sibling section fetched it.
	onMount(() => {
		if (fetchStatus === 'idle' || fetchStatus === 'error') {
			void refreshHomes();
		}
	});
</script>

<Text styleType="body" class="mb-s mt-m">
	{$format('homes_shared_group', { default: 'Shared homes' })}
</Text>

{#if isFetching && sharedHomes.length === 0}
	<div class="d-flex justify-content-center">
		<Loader size="m" />
	</div>
{:else if sharedHomes.length === 0}
	<Text styleType="body-small" class="text-color-muted">
		{$format('settings_shared_to_me_empty', {
			default: 'No homes have been shared with you yet.',
		})}
	</Text>
{:else}
	{#each sharedHomes as home (home.id + (home.sub ?? ''))}
		<div class="mb-s">
			<SharedHomeItem {home} />
		</div>
	{/each}
{/if}
